import { createAction, props } from '@ngrx/store';

import { Batch } from 'app/shared/features/batch-selector/models';

export const updateBatches = createAction('[Batch Selection] Update Batch', props<{ batches: Batch[] }>());
